module.exports = __webpack_public_path__ + "media/images/strategic-partners/smartheart-fb376138b38c0f69b3505bdd4d6f0858.jpeg";